import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import HotSection from "./components/HotSection";
import CultSection from "./components/CultSection";
import DarkSection from "./components/DarkSection";
import BrainSection from "./components/BrainSection";
import RankSection from "./components/RankSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <HotSection />
        <CultSection />
        <DarkSection />
        <BrainSection />
        <RankSection />
        <AboutSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}